import { Component, OnInit, ViewChild } from '@angular/core';
import {UploadAdjustmentFileService} from '../upload-adjustmentfile.service'
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators, NgForm, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HelperService } from '../../core/helper';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-upload-newadjustmentfile-screen',
    templateUrl: './upload-newadjustmentfile.screen.component.html',
    styleUrls: ['./upload-newadjustmentfile.screen.component.scss'],
    providers: [
        UploadAdjustmentFileService
    ],
    standalone: false
})
export class UploadNewAdjustmentFileScreenComponent implements OnInit {
     @ViewChild('f', { static: false }) floatingLabelForm: NgForm;

     selectedMonthYear: String;
     note: String;
     formValidationList: any;
     filetoupload: Array<File>;

     constructor(
        private _uploadAdjustmentFileService: UploadAdjustmentFileService,
        private _router: Router,
        private spinner: NgxSpinnerService,
        private _helper: HelperService,
        public activeModal: NgbActiveModal) {
  
  
        this.note = '';
        this.filetoupload = [];
        this.selectedMonthYear = null;
        this.formValidationList = { 'filetoupload': '' };
     }
     ngOnInit() {
        this.selectedMonthYear = localStorage.getItem('selectedMonthYearLocalStorageUploadAdjustment');
     }
  
    fileChangeEvent(fileInput: any) {
    const file = fileInput.target.files[0];
    if (!file) return;
  
    const fileName = file.name.toLowerCase();
  
    if (fileName.endsWith('.csv')) {
      // Handle CSV
      const reader = new FileReader();
  
      reader.onload = (e: any) => {
        let csvContent = e.target.result;
  
        console.log('CSV Before Cleaning:', csvContent);
  
        // Remove special characters
        const cleanedCSV = csvContent.replace(/[^\x20-\x7E\r\n\t]/g, '');
  
        console.log('CSV After Cleaning:', cleanedCSV);
  
        // Create new cleaned File object
        const cleanedFile = new File([cleanedCSV], file.name, {
          type: file.type
        });
  
        this.filetoupload = [cleanedFile];
        this.validateForm();
      };
  
      reader.readAsText(file);
    } else if (fileName.endsWith('.xlsx')) {
      // Handle XLSX (Excel)
      const reader = new FileReader();
  
      reader.onload = async (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
  
        const cleanedSheets: { [sheetName: string]: any[][] } = {};
  
        workbook.SheetNames.forEach(sheetName => {
          const sheet = workbook.Sheets[sheetName];
          const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  
          const cleanedData = sheetData.map((row: any[]) =>
            row.map((cell: any) =>
              typeof cell === 'string'
                ? cell.replace(/[^\x20-\x7E\r\n\t]/g, '')
                : cell
            )
          );
  
          cleanedSheets[sheetName] = cleanedData;
        });
  
        const newWorkbook = XLSX.utils.book_new();
        for (let sheetName in cleanedSheets) {
          const worksheet = XLSX.utils.aoa_to_sheet(cleanedSheets[sheetName]);
          XLSX.utils.book_append_sheet(newWorkbook, worksheet, sheetName);
        }
  
        const arrayBuffer = XLSX.write(newWorkbook, {
          bookType: 'xlsx',
          type: 'array'
        });
  
        const cleanedBlob = new Blob([arrayBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
  
        const cleanedFile = new File([cleanedBlob], file.name, {
          type: file.type
        });
        
        this.filetoupload = [cleanedFile];
        this.validateForm();
      };
  
      reader.readAsArrayBuffer(file);
    } else {
      console.warn('Unsupported file type');
    }
  }
  
  
     validateForm() {
        let isValid = true;

        this.formValidationList.filetoupload = "";
        if (this.filetoupload.length == 0) {
           this.formValidationList.filetoupload = "This field is required!";
           isValid = false;
        } else {
           const validFileExtension = ['xlsx', 'csv', 'xls'];
           const fileName = this.filetoupload[0].name;
           const fileExtension = fileName.split('.').pop();
           if (!validFileExtension.includes(fileExtension)) {
              this.formValidationList.filetoupload = "Invalid file extension!";
              isValid = false;
           }
        }
        return isValid;
     }
    // submitForm() {
    //   if (this.validateForm()) {
    //     console.log("Form is valid, ready to submit:", this.filetoupload);
    //     // Call API here
    //   }
    // }
     submitForm() {
      if (this.validateForm()) {
         this.spinner.show();
         const params = {
            'note': this.note,
            'selectedMonthYear': this.selectedMonthYear,
         };
         console.log("params",params)
         this._uploadAdjustmentFileService.submitUploadAdjustmentForm(params, this.filetoupload).then(
            (data) => {
              console.log("hhhhhh")
              console.log("data", data)
               this.spinner.hide();
               this.closePopup();
            },
            (error) => {
               this.spinner.hide();
               this.closePopup();
            }
         )
      }
   }
     closePopup() {
        this.activeModal.close('Close click');
     }
  }
  